import React from 'react';

import cls from '@widgets/Files/UI/FileFolder/ui/FileFolder.module.css';

interface IFileFolderNameProps {
    folderName: string;
}

export const FolderName = ({ folderName }: IFileFolderNameProps) => (
    <span className={cls.name}>{folderName}</span>
);
